import { toIssueKey, type IssueKey } from '@atlassian/jira-shared-types';

export const parseIssueKey = (href: string): IssueKey => {
	const path = href.split('/').pop();
	// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
	return toIssueKey(path.split('?')[0].split('#')[0]);
};
